/*
    #StorageManager
       This component provides an interface to control and store the information with different kinds of storage. By default use SessionStorageManager (SessionStorage).

        # get:
           This method is for reading a value stored

        # set:
           This method is to store a value

        # remove:
           This method is to remove a value stored

        # addTimes:
           This method is to add a number to a integer value stored

        # subTimes:
           This method is to subtract a number to a integer value stored
*/

const StorageManager = manager => {
    const instance = {
        get: function(key) {
            return instance._manager._get(key);
        },

        set: function(key, value) {
            return instance._manager._set(key, value);
        },

        remove: function(key) {
            return instance._manager._remove(key);
        },

        addTimes: function(key, num) {
            const add = parseInt(num || 1);
            return instance._manager._add(key, add);
        },

        subTimes: function(key, num) {
            const sub = parseInt(num || 1);
            return instance._manager._sub(key, sub);
        }
    };

    instance._manager = manager || SessionStorageManager;

    return instance;
};

export const SessionStorageManager = {
    _get: function(key) {
        return sessionStorage.getItem(key);
    },

    _set: function(key, value) {
        return sessionStorage.setItem(key, value);
    },

    _remove: function(key) {
        return sessionStorage.removeItem(key);
    },

    _add: function(key, num) {
        const current = parseInt(SessionStorageManager._get(key) || 0);
        SessionStorageManager._set(key, current + num);
    },

    _sub: function(key, num) {
        SessionStorageManager._add(key, num * -1);
    }
};

export const LocalStorageManager = {
    _get: function(key) {
        return localStorage.getItem(key);
    },

    _set: function(key, value) {
        return localStorage.setItem(key, value);
    },

    _remove: function(key) {
        return localStorage.removeItem(key);
    },

    _add: function(key, num) {
        const current = parseInt(LocalStorageManager._get(key) || 0);
        LocalStorageManager._set(key, current + num);
    },

    _sub: function(key, num) {
        LocalStorageManager._add(key, num * -1);
    }
};

export default StorageManager;
